import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BulkUpload from '../Commons/BulkUpload';

import { FlexRow, Bold, InputGroup, Select, MenuItem, SectionRow } from './Styles/UpdateBulkBucketPrices';

import { updateErrorMessage, updateSuccessMessage, updateMessage, updateError } from '../../actions/commonActions';
import { setUploadInventoryFileAction, setUploadInventoryFileBatch, downloadTemplateFile, uploadFilledTemplateFile } from '../../actions/inventoryActionsV2';
import { fetchSPJBatchJobs, fetchSPJBatchMetric, clearSPJFailed, downloadSPJErrors } from '../../actions/spjActions';

import { SPJ_ACTIONS } from '../../commons/utils';

class UpdateBulkBucketPrices extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			bucketOptions: [],
			selectedBucketOptions: [],
		};
	}

	componentDidMount() {
		let bucketOptions = [{ name: 'BASE PRICE', value: 'price', disabled: false }];
		let { bucketState } = this.props;

		Object.keys(bucketState).forEach((bucket) => {
			bucketOptions.push({
				name: bucketState[bucket].alias.toUpperCase(),
				value: bucket,
				disabled: bucketState[bucket] && bucketState[bucket].pending_map_updates > 0,
			});
		});

		this.setState({ bucketOptions: bucketOptions });
	}

	handleInput = (key, value, next = null) => {
		this.setState(
			{
				[key]: value,
			},
			next
		);
	};

	downloadTemplateFile = async (action, onError) => {
		let { selectedBucketOptions } = this.state;
		let body = {
			sources: selectedBucketOptions,
		};

		await this.props.downloadTemplateFile(action, onError, body);
	};

	uploadFilledTemplateFile = async (action, formData, onSuccess, onError) => {
		await this.props.uploadFilledTemplateFile(action, formData, onSuccess, onError);
	};

	render() {
		let { bucketOptions, selectedBucketOptions } = this.state;
		let { open, uploadInventoryFileAction, uploadInventoryFileBatch, uploadInventoryFileType } = this.props;

		return open ? (
			<BulkUpload
				open={open}
				title={'Update Bucket Prices In Bulk'}
				spjAction={SPJ_ACTIONS.PRICE_UPDATE}
				uploadFileAction={uploadInventoryFileAction || ''}
				uploadFileBatch={uploadInventoryFileBatch || ''}
				uploadFileType={uploadInventoryFileType || ''}
				disableDownload={!selectedBucketOptions.length}
				onClose={this.props.toggle}
				onSuccess={this.props.onSuccess}
				downloadTemplateFile={this.downloadTemplateFile}
				uploadFilledTemplateFile={this.uploadFilledTemplateFile}
				setUploadFileAction={this.props.setUploadInventoryFileAction}
				setUploadFileBatch={this.props.setUploadInventoryFileBatch}
			>
				<FlexRow style={{ margin: '0.5rem auto', textAlign: 'center' }}>
					Download the sample file and add bucket price details. Upload the file to update prices for multiple items in the inventory at once.
				</FlexRow>

				<FlexRow style={{ justifyContent: 'center', textAlign: 'center', paddingTop: '0.5rem' }}>
					<Bold>Rules:</Bold>
				</FlexRow>

				<FlexRow style={{ justifyContent: 'left', textAlign: 'left', paddingBottom: '0.5rem' }}>
					<ul style={{ listStyle: 'circle' }}>
						<li>
							<Bold>Do not alter</Bold> the file headers.	
						</li>

						<li>
							<Bold>Item ID</Bold> is a mandatory field.
						</li>

						<li>
							<Bold>Locked buckets</Bold> are disabled in the bucket dropdown.
						</li>

						<li>
							<Bold>Prices</Bold> should be a zero or positive numeric value, without currency symbol.
						</li>
					</ul>
				</FlexRow>

				<SectionRow>
					<InputGroup
						label='Select the buckets you want to download the template for'
						markRequired={true}
					>
						<Select
							multiple
							name={'selected_buckets'}
							placeholder='Select buckets'
							value={selectedBucketOptions.length ? selectedBucketOptions : []}
							disabled={false}
							onChange={(e) => {
								this.handleInput('selectedBucketOptions', e.target.value);
							}}
						>
							{bucketOptions.map((item) => (
								<MenuItem
									value={item.value}
									disabled={item.disabled}
								>
									{item.name}
								</MenuItem>
							))}
						</Select>
					</InputGroup>
				</SectionRow>
			</BulkUpload>
		) : null;
	}
}

const mapStateToProps = (state) => {
	return {
		uploadInventoryFileAction: state.inventory.uploadInventoryFileAction || '',
		uploadInventoryFileBatch: state.inventory.uploadInventoryFileBatch || '',
		uploadInventoryFileType: state.inventory.uploadInventoryFileType || '',
	};
};

const mapDispatch = {
	setUploadInventoryFileAction,
	downloadTemplateFile,
	uploadFilledTemplateFile,
	setUploadInventoryFileBatch,
	fetchSPJBatchJobs,
	fetchSPJBatchMetric,
	clearSPJFailed,
	downloadSPJErrors,
	updateError,
	updateErrorMessage,
	updateMessage,
	updateSuccessMessage,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(UpdateBulkBucketPrices));
